import React, { PropsWithChildren, useEffect } from 'react';
import { App } from 'antd';

import { defaultVersion, isSameVersion, useCabinetStore } from 'store';

export const AppEncapsulation: React.FC<PropsWithChildren> = ({ children }) => {
    const { modal } = App.useApp();
    const { resetCabinets } = useCabinetStore((state) => state);

    useEffect(() => {
        if (!isSameVersion()) {
            modal.warning({
                title: 'New Version Detected',
                content: 'A new version of the app has been detected. Please reset your cabinets to the default version to continue!',
                okText: 'Reset Cabinets',
                onOk: () => {
                    resetCabinets();
                    localStorage.setItem('version', defaultVersion);
                },
            });
        }
    }, [modal, resetCabinets]);

    return (
        <React.Fragment>
            { children }
        </React.Fragment>
    );
};
